import Absensi from "../../../../../components/categories/siakad/lms/data_absensi/HomeAdmin";
export default function Home() {
  
  return (
    <Absensi />
  );
}
